import React, { useEffect, useState } from 'react';
import './SocialOverview.css';
import { MdOutlineInfo } from "react-icons/md";
import { BiLogoTelegram } from "react-icons/bi";
import BlurChart from "../../assets/blur-chart.webp";
import { BiSolidHourglass } from "react-icons/bi";

const Clock = BiSolidHourglass  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const TG = BiLogoTelegram  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

interface ProjectInfoProps {
  ca: any;
}

  export interface ChartData {
    tracking_telegram_users: boolean;
    tracking_telegram_active_users: boolean;
    telegram_users: number;
    telegram_users_trend: string;
    telegram_users_percentage_change_h24: number;
    telegram_active_users: number;
    tracking: boolean;
    telegram_active_users_trend: string;
    telegram_active_users_percentage_change_h24: number;
  }
  

const SocialOverview: React.FC<ProjectInfoProps> = ({ ca }) => {
  const [data, setData] = useState<ChartData>();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`https://aen226grpxvqujgu7zid7k6qsq0xwuui.lambda-url.us-east-1.on.aws/?id=${ca}`);
        if (!res.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await res.json();
        setData(data);
      } catch (err: any) {
        console.error(err.message);
      }
    };

    if (ca) {
      fetchData();
    }
  }, [ca]);

  return (
    <div className="social-embed">
      <div className='chart-frames'>
          {data && data.tracking_telegram_users === false ? (
            <>
              <div className="telegram-smaller-box">
                <div className="chart-title">
                  <TG /> Members <div className={`badge-tg ${data.telegram_users_trend}`}>{data.telegram_users_trend}</div>
                </div>
                <div className='telegram-amounts'>
                  <div className='tg-amount'>{data.telegram_users.toLocaleString('en-US')}</div>
                <div
                    className="perc-change"
                    style={{
                      color: data.telegram_users_percentage_change_h24 > 0
                        ? 'rgb(14,203,129)'
                        : data.telegram_users_percentage_change_h24 < 0
                          ? 'rgb(246,70,93)'
                          : 'grey'
                    }}                  >
                    {data.telegram_users_percentage_change_h24 >= 0 ? "+" : ""}{data.telegram_users_percentage_change_h24?.toFixed(2)}%
                  </div>
                </div>
              </div>
              <iframe src={`https://i73nm2ep37yf2x75fdcrsr6hou0xwioz.lambda-url.us-east-1.on.aws/${ca}/telegram_users`}></iframe>
            </>
            ) :
            (
              <>
                <div className="telegram-smaller-box">
                  <div className="chart-title">
                    <TG /> Members
                  </div>
                  <div className='telegram-amounts'>
                    <div className='tg-amount' style={{fontSize: '12px', lineHeight: '24px'}}>Not available yet...</div>
                  </div>
                </div>
                <div className="chart-unavailable">
                  <img className='blur-chart' src={BlurChart}></img>
                  <div className='na-text'><Clock /> Tracking data...</div>
                </div>
              </>
            )
          }
      </div>
      <div className='chart-frames'>
          {data && data.tracking_telegram_active_users === false ? (
            <>
              <div className="telegram-smaller-box">
                <div className="chart-title">
                  <TG /> Active Members <div className={`badge-tg ${data.telegram_active_users_trend === 'increasing' ? "increasing" : "decreasing"}`}>{data.telegram_active_users_trend}</div>
                </div>
                <div className='telegram-amounts'>
                  <div className='tg-amount'>{data.telegram_active_users.toLocaleString('en-US')}</div>
                <div
                    className="perc-change"
                    style={{
                      color: data.telegram_active_users_percentage_change_h24 > 0
                        ? 'rgb(14,203,129)'
                        : data.telegram_active_users_percentage_change_h24 < 0
                          ? 'rgb(246,70,93)'
                          : 'grey'
                    }}                  >
                    {data.telegram_active_users_percentage_change_h24 >= 0 ? "+" : ""}{data.telegram_active_users_percentage_change_h24?.toFixed(2)}%
                  </div>
                </div>
              </div>
              <iframe src={`https://i73nm2ep37yf2x75fdcrsr6hou0xwioz.lambda-url.us-east-1.on.aws/${ca}/telegram_active_users`}></iframe>
            </>
            ) :
            (
              <>
                <div className="telegram-smaller-box">
                  <div className="chart-title">
                    <TG /> Active Members
                  </div>
                  <div className='telegram-amounts'>
                    <div className='tg-amount' style={{fontSize: '12px', lineHeight: '24px'}}>Not available yet...</div>
                  </div>
                </div>
                <div className="chart-unavailable">
                  <img className='blur-chart' src={BlurChart}></img>
                  <div className='na-text'><Clock /> Tracking data...</div>
                </div>
              </>
            )
          }
      </div>
    </div>
  );
};

export default SocialOverview;
